import { useMemo, useState } from 'react';
import { LifeBuoy } from 'lucide-react';
import type { ComponentProps } from 'react';
import type { SupportReportRequest } from '@/api/types';
import { Button } from '@/components/ui/button';
import { buildSupportReport } from '@/services/support/report';
import { SupportReportDialog } from './SupportReportDialog';

export const SupportReportButton = ({
  error,
  report,
  componentStack,
  size,
  variant = 'outline',
  className,
}: {
  error?: unknown;
  report?: SupportReportRequest;
  componentStack?: string | null;
  size?: ComponentProps<typeof Button>['size'];
  variant?: ComponentProps<typeof Button>['variant'];
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const baseReport = useMemo(
    () => report ?? buildSupportReport(error, componentStack),
    [report, error, componentStack]
  );

  return (
    <>
      <Button variant={variant} size={size} onClick={() => setOpen(true)} className={className}>
        <LifeBuoy />
        Report
      </Button>
      <SupportReportDialog open={open} onOpenChange={setOpen} baseReport={baseReport} />
    </>
  );
};
